package com.dignicate.web.ui.util

import kotlinx.browser.window

fun navigateAndScrollTop(navigate: (String) -> Unit, path: String) {
    // invoke existing navigation
    try {
        navigate(path)
    } catch (_: Throwable) {
        // swallow; navigate implementations may throw in rare cases
    }

    // ensure scroll resets after navigation/render; instant reset
    try {
        window.setTimeout({
            try { window.scrollTo(0.0, 0.0) } catch (_: Throwable) {}
        }, 0)
    } catch (_: Throwable) {
        // ignore if environment doesn't support setTimeout
    }
}

